// extracted by css-extract-rspack-plugin
export default {"heading3":"Heading3_heading3__J22Xd"};